<template>
  <div class="gs-app gm-mail-lead-detail">
    <!-- Loader -->
    <portal to="loaderTarget">
      <div class="absolute bg-grey-100 bg-opacity-50 h-full left-0 top-0 w-full z-99" v-if="isLoading">
        <gd-loader :label="$t('frontend_loading')"/>
      </div>
    </portal>
    
    <div class="gm-mail-lead-detail__header flex justify-between items-center">
      <div class="w-full flex items-center">
        <div class="flex mr-4">
          <v-gravatar
            class="rounded-full"
            hash="f3ada405ce890b6f8204094deb12d8a8"
            alt="Nobody"
            :size="64"
            default-img="mm"
          />
        </div>
        <div class="flex flex-col">
          <p class="leads-field text-2xl font-bold text-deep-dark">
            {{ demoMode ? basicText : this.model.first_name ? this.model.first_name : ' ' }}
            {{ demoMode ? basicText : this.model.last_name ? this.model.last_name : '' }}
          </p>
          <p class="text-sm font-semibold text-grey-700">
            {{ $t('frontend_groovemail_created_on') }}
            <span class="font-bold text-deep-dark">{{
              this.created_at_data
            }}</span>
          </p>
        </div>
      </div>
      <div>
        <gd-button
          size="auto"
          variant="outline"
          @click="goBackToLeadsListing()"
        >
          {{ $t('frontend_groovemail_mail_lead_show_back') }}
        </gd-button>
      </div>
    </div>
    <div class="gm-mail-lead-detail__grid w-full flex flex-row my-8">
      <CardLayout class="gm-mail-lead-detail__profile-card w-3/5 mr-3 leads-deatil-personal-info">
        <template slot="header">
          <div
            class="
              flex
              justify-between
              items-center
              border-b-2 border-grey-300
              py-4
              px-6
            "
          >
            <div class="w-2/3">
              <p class="text-lg leading-6 font-semibold text-deep-dark">
                {{ $t('frontend_groovemail_lead_detail_lead_information_header') }}
              </p>
              <p class="text-sm text-grey-700">
                {{ $t('frontend_groovemail_lead_detail_personal_details_sub_header') }}
              </p>
            </div>
            <div class="w-1/3 flex justify-end" v-if="isUnRestrictedAccount">
              <gd-button
                size="auto"
                variant="outline"
                v-if="editfieldsMode"
                @click="turnOffEditMode()"
              >
                {{ $t('frontend_cancel') }}
              </gd-button>

              <gd-button
                size="auto"
                variant="outline"
                @click="editfield()"
                v-if="!editfieldsMode"
              >
                {{ $t('frontend_edit') }}
              </gd-button>

              <gd-button
                class="ml-2"
                size="auto"
                variant="primary"
                @click="savedata"
                v-if="editfieldsMode"
              >
                {{ $t('frontend_save') }}
              </gd-button>
            </div>
          </div>
        </template>
        <template slot="content">
          <div class="w-full py-4 px-6">
            <div class="flex">
              <div
                class="my-3 w-1/2 inline-block"
                v-if="
                  editfieldsMode || (!editfieldsMode && this.model.first_name)
                "
              >
                <label class="w-full text-sm font-semibold text-grey-600">
                  {{ $t('frontend_groovemail_mail_lead_index_firstname') }}
                </label>
                <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                  <text-input
                    variant="base"
                    v-model="model.first_name"
                    :placeholder="$t('frontend_groovemail_mail_lead_index_firstname')"
                    :validator="$v.model.first_name"
                  />
                </div>
                <div class="w-full flex mb-3" v-else>
                  <label
                    class="
                      leads-field
                      font-bold
                      text-md text-deep-dark
                      pr-4
                      break-all
                    "
                    >{{
                       demoMode ? basicText : this.model.first_name
                        ? this.model.first_name
                        : $t('frontend_groovemail_not_available')
                    }}</label
                  >
                </div>
              </div>

              <div
                class="my-3 w-1/2 inline-block"
                v-if="
                  editfieldsMode || (!editfieldsMode && this.model.last_name)
                "
              >
                <label class="w-full text-sm font-semibold text-grey-600">
                  {{ $t('frontend_groovemail_mail_lead_index_lastname') }}
                </label>
                <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                  <text-input
                    variant="base"
                    v-model="model.last_name"
                    :placeholder="$t('frontend_groovemail_mail_lead_index_lastname')"
                    :validator="$v.model.last_name"
                  />
                </div>
                <div class="w-full flex mb-3" v-else>
                  <label
                    class="
                      leads-field
                      font-bold
                      text-md text-deep-dark
                      pr-4
                      break-all
                    "
                    >{{
                       demoMode ? basicText : this.model.last_name
                        ? this.model.last_name
                        : $t('frontend_groovemail_not_available')
                    }}</label
                  >
                </div>
              </div>
            </div>

            <div class="flex">
              <div
                class="my-3 w-full inline-block"
                v-if="editfieldsMode || (!editfieldsMode && this.model.email)"
              >
                <label class="w-full text-sm font-semibold text-grey-600">
                  {{ $t('frontend_groovemail_mail_lead_index_email') }}
                </label>
                <div
                  class="w-full mb-4 pr-4 cursor-not-allowed"
                  v-if="editfieldsMode"
                  :title="
                    $t(
                      'frontend_groovemail_mail_lead_email_field_not_editable'
                    )
                  "
                >
                  <text-input
                    class="pointer-events-none"
                    variant="base"
                    v-model="model.email"
                    :placeholder="$t('frontend_groovemail_mail_lead_index_email')"
                    :validator="$v.model.email"
                    :disabled="true"
                  />
                </div>
                <div class="w-full flex mb-3" v-else>
                  <label
                    class="
                      leads-field
                      font-bold
                      text-md text-deep-dark
                      pr-4
                      break-all
                    "
                    >{{
                        demoMode ? basicEmailText : this.model.email
                        ? this.model.email
                        : $t('frontend_groovemail_not_available')
                    }}</label
                  >
                </div>
              </div>
            </div>

            <div class="flex">
              <div
                class="my-3 w-full inline-block"
                v-if="
                  editfieldsMode ||
                  (!editfieldsMode && this.model.phone_number)
                "
              >
                <label class="w-full text-sm font-semibold text-grey-600">
                  {{ $t('frontend_groovemail_mail_lead_index_phone') }}
                </label>
                <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                  <VuePhoneNumberInput
                    :border-radius="6"
                    :default-country-code="default_country_code"
                    :show-code-on-list="true"
                    v-model="model.phone_number"
                    @update="getPhoneData($event)"
                  />
                  <p
                    class="w-full error text-danger mt-1 text-sm"
                    v-if="
                      submitted &&
                      !this.phoneData.isValid &&
                      this.model.phone_number
                    "
                  >
                    {{
                      $t(
                        'frontend_groovemail_settings_integeration_invalid_phone_number'
                      )
                    }}
                  </p>
                </div>
                <div class="w-full flex mb-3" v-else>
                  <label
                    class="
                      leads-field
                      font-bold
                      text-md text-deep-dark
                      pr-4
                      break-all
                    "
                    >{{
                        demoMode ? basicContactText : this.model.phone_number
                        ? this.maillead.contact.country_code
                          ? this.maillead.contact.country_code +
                            ' ' +
                            this.model.phone_number
                          : this.model.phone_number
                        : $t('frontend_groovemail_not_available')
                    }}</label
                  >
                </div>
              </div>
            </div>

            <div
              class="my-3 w-1/2 inline-block"
              v-if="editfieldsMode || (!editfieldsMode && this.model.company)"
            >
              <label class="w-full text-sm font-semibold text-grey-600">
                {{ $t('frontend_groovemail_mail_lead_index_company') }}
              </label>
              <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                <text-input
                  variant="base"
                  v-model="model.company"
                  :placeholder="$t('frontend_groovemail_mail_lead_index_company')"
                />
              </div>
              <div class="w-full flex mb-3" v-else>
                <label
                  class="
                    leads-field
                    font-bold
                    text-md text-deep-dark
                    pr-4
                    break-all
                  "
                  >{{
                      demoMode ? basicText : this.model.company
                      ? this.model.company
                      : $t('frontend_groovemail_not_available')
                  }}</label
                >
              </div>
            </div>

            <div
              class="my-3 w-1/2 inline-block"
              v-if="
                editfieldsMode || (!editfieldsMode && this.model.address_1)
              "
            >
              <label class="w-full text-sm font-semibold text-grey-600">
                {{ $t('frontend_groovemail_mail_lead_index_adress1') }}
              </label>
              <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                <text-input
                  variant="base"
                  v-model="model.address_1"
                  :placeholder="$t('frontend_groovemail_mail_lead_index_adress1')"
                />
              </div>
              <div class="w-full flex mb-3" v-else>
                <label
                  class="
                    leads-field
                    font-bold
                    text-md text-deep-dark
                    pr-4
                    break-all
                  "
                  >{{
                      demoMode ? basicText : this.model.address_1
                      ? this.model.address_1
                      : $t('frontend_groovemail_not_available')
                  }}</label
                >
              </div>
            </div>

            <div
              class="my-3 w-1/2 inline-block"
              v-if="
                editfieldsMode || (!editfieldsMode && this.model.address_2)
              "
            >
              <label class="w-full text-sm font-semibold text-grey-600">
                {{ $t('frontend_groovemail_mail_lead_index_adress2') }}
              </label>
              <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                <text-input
                  variant="base"
                  v-model="model.address_2"
                  :placeholder="$t('frontend_groovemail_mail_lead_index_adress2')"
                />
              </div>
              <div class="w-full flex mb-3" v-else>
                <label
                  class="
                    leads-field
                    font-bold
                    text-md text-deep-dark
                    pr-4
                    break-all
                  "
                  >{{
                      demoMode ? basicText : this.model.address_2
                      ? this.model.address_2
                      : $t('frontend_groovemail_not_available')
                  }}</label
                >
              </div>
            </div>

            <div
              class="my-3 w-1/2 inline-block"
              v-if="editfieldsMode || (!editfieldsMode && this.model.city)"
            >
              <label class="w-full text-sm font-semibold text-grey-600">
                {{ $t('frontend_groovemail_mail_lead_index_city') }}
              </label>
              <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                <text-input
                  variant="base"
                  v-model="model.city"
                  :placeholder="$t('frontend_groovemail_mail_lead_index_city')"
                />
              </div>
              <div class="w-full flex mb-3" v-else>
                <label
                  class="
                    leads-field
                    font-bold
                    text-md text-deep-dark
                    pr-4
                    break-all
                  "
                  >{{
                      demoMode ? basicText : this.model.city
                      ? this.model.city
                      : $t('frontend_groovemail_not_available')
                  }}</label
                >
              </div>
            </div>

            <div
              class="my-3 w-1/2 inline-block"
              v-if="editfieldsMode || (!editfieldsMode && this.model.state)"
            >
              <label class="w-full text-sm font-semibold text-grey-600">
                {{ $t('frontend_groovemail_mail_lead_index_state') }}
              </label>
              <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                <text-input
                  variant="base"
                  v-model="model.state"
                  :placeholder="$t('frontend_groovemail_mail_lead_index_state')"
                />
              </div>
              <div class="w-full flex mb-3" v-else>
                <label
                  class="
                    leads-field
                    font-bold
                    text-md text-deep-dark
                    pr-4
                    break-all
                  "
                  >{{
                      demoMode ? basicText :this.model.state
                      ? this.model.state
                      : $t('frontend_groovemail_not_available')
                  }}</label
                >
              </div>
            </div>

            <div
              class="my-3 w-1/2 inline-block"
              v-if="editfieldsMode || (!editfieldsMode && this.model.country)"
            >
              <label class="w-full text-sm font-semibold text-grey-600">
                {{ $t('frontend_groovemail_mail_lead_index_country') }}
              </label>
              <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                <text-input
                  variant="base"
                  v-model="model.country"
                  :placeholder="$t('frontend_groovemail_mail_lead_index_country')"
                />
              </div>
              <div class="w-full flex mb-3" v-else>
                <label
                  class="
                    leads-field
                    font-bold
                    text-md text-deep-dark
                    pr-4
                    break-all
                  "
                  >{{
                      demoMode ? basicText : this.model.country
                      ? this.model.country
                      : $t('frontend_groovemail_not_available')
                  }}</label
                >
              </div>
            </div>

            <div
              class="my-3 w-1/2 inline-block"
              v-if="editfieldsMode || (!editfieldsMode && this.model.zip)"
            >
              <label class="w-full text-sm font-semibold text-grey-600">
                {{ $t('frontend_groovemail_mail_lead_index_zipcode') }}
              </label>
              <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                <text-input
                  variant="base"
                  v-model="model.zip"
                  :placeholder="$t('frontend_groovemail_mail_lead_index_zipcode')"
                />
              </div>
              <div class="w-full flex mb-3" v-else>
                <label
                  class="
                    leads-field
                    font-bold
                    text-md text-deep-dark
                    pr-4
                    break-all
                  "
                  >{{
                      demoMode ? basicText : this.model.zip
                      ? this.model.zip
                      : $t('frontend_groovemail_not_available')
                  }}</label
                >
              </div>
            </div>

            <div
              class="my-3 w-1/2 inline-block"
              v-if="editfieldsMode || (!editfieldsMode && this.model.url)"
            >
              <label class="w-full text-sm font-semibold text-grey-600">
                {{ $t('frontend_groovemail_mail_lead_index_url') }}
              </label>
              <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                <text-input
                  variant="base"
                  v-model="model.url"
                  :placeholder="$t('frontend_groovemail_mail_lead_index_url')"
                />
              </div>
              <div class="w-full flex mb-3" v-else>
                <label
                  class="
                    leads-field
                    font-bold
                    text-md text-deep-dark
                    pr-4
                    break-all
                  "
                  >{{
                      demoMode ? basicUrlText :this.model.url
                      ? this.model.url
                      : $t('frontend_groovemail_not_available')
                  }}</label
                >
              </div>
            </div>

            <div
              class="my-3 w-1/2 inline-block"
              v-if="
                editfieldsMode || (!editfieldsMode && this.model.tax_number)
              "
            >
              <label class="w-full text-sm font-semibold text-grey-600">
                {{ $t('frontend_groovemail_mail_lead_index_taxnumber') }}
              </label>
              <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                <text-input
                  variant="base"
                  v-model="model.tax_number"
                  :placeholder="$t('frontend_groovemail_mail_lead_index_taxnumber')"
                />
              </div>
              <div class="w-full flex mb-3" v-else>
                <label
                  class="
                    leads-field
                    font-bold
                    text-md text-deep-dark
                    pr-4
                    break-all
                  "
                  >{{
                      demoMode ? basicText : this.model.tax_number
                      ? this.model.tax_number
                      : $t('frontend_groovemail_not_available')
                  }}</label
                >
              </div>
            </div>

            <div
              class="my-3 w-1/2 inline-block"
              v-if="
                editfieldsMode ||
                (!editfieldsMode && this.model.billing_address)
              "
            >
              <label class="w-full text-sm font-semibold text-grey-600">
                {{ $t('frontend_groovemail_mail_lead_index_billing') }}
              </label>
              <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                <text-input
                  variant="base"
                  v-model="model.billing_address"
                  :placeholder="$t('frontend_groovemail_mail_lead_index_billing')"
                />
              </div>
              <div class="w-full flex mb-3" v-else>
                <label
                  class="
                    leads-field
                    font-bold
                    text-md text-deep-dark
                    pr-4
                    break-all
                  "
                  >{{
                      demoMode ? basicText : this.model.billing_address
                      ? this.model.billing_address
                      : $t('frontend_groovemail_not_available')
                  }}</label
                >
              </div>
            </div>

            <div class="my-3 w-1/2 inline-block">
              <label class="w-full text-sm font-semibold text-grey-600">
                {{ $t('frontend_groovemail_created_at') }}
              </label>
              <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                <text-input
                  variant="base"
                  v-model="created_at_data"
                  :placeholder="$t('frontend_groovemail_created_at')"
                  :disabled="true"
                />
              </div>
              <div class="w-full flex mb-3" v-else>
                <label
                  class="
                    leads-field
                    font-bold
                    text-md text-deep-dark
                    pr-4
                    break-all
                  "
                  >{{
                    created_at_data
                      ? created_at_data
                      : $t('frontend_groovemail_not_available')
                  }}</label
                >
              </div>
            </div>

            <div
              class="my-3 w-1/2 inline-block"
              v-for="customField in customFieldSingleValue"
              :key="customField.key"
            >
              <div v-if="customField.key != 'id'">
                <label
                  class="
                    w-full
                    text-sm
                    font-semibold
                    text-grey-600
                    capitalize
                  "
                  >{{ updateCustomFieldLabel(customField.key) }}</label
                >
                <div class="w-full mb-4 pr-4" v-if="editfieldsMode">
                  <text-input
                    variant="base"
                    v-model="model.custom_field[customField.key]"
                    :placeholder="customField.key"
                  />
                </div>
                <div v-else>
                  <label
                    class="
                      leads-field
                      font-bold
                      text-md text-deep-dark
                      pr-4
                      break-all
                    "
                    >{{ customField.val }}</label
                  >
                </div>
              </div>
            </div>

            <div
              class="my-3 w-full"
              v-for="customField in customFieldMultipleValue"
              :key="customField.key"
            >
              <div
                v-if="
                  customField.key != 'id' &&
                  customField.val &&
                  customField.val.length
                "
              >
                <label
                  class="
                    w-full
                    text-sm
                    font-semibold
                    text-grey-600
                    capitalize
                  "
                  >{{ updateCustomFieldLabel(customField.key) }}</label
                >
                <div class="mt-3">
                  <div
                    class="w-full flex flex-wrap"
                    v-if="customField.val && customField.val.length"
                  >
                    <div
                      class="
                        mb-2
                        flex
                        rounded-lead-chips
                        text-xs
                        bg-primary text-primary-invert
                        mr-2
                      "
                      v-for="(cusFieldValue, index) in customField.val"
                      :key="index"
                    >
                      <div
                        class="py-1 pl-2"
                        :class="{
                          'pr-1': editfieldsMode,
                          'pr-2': !(editfieldsMode && isUnRestrictedAccount),
                        }"
                      >
                        {{ cusFieldValue }}
                      </div>
                      <div
                        class="py-1 pl-1 pr-2"
                        v-if="editfieldsMode && isUnRestrictedAccount"
                      >
                        <div
                          class="cursor-pointer"
                          @click="removeCustomField(customField.key, index)"
                        >
                          <i class="fas fa-times"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="my-3 w-full">
              <label class="w-full text-sm font-semibold text-grey-600 mb-3">
                {{ $t('frontend_groovemail_mail_lead_show_tags') }}
              </label>
              <div class="w-full">
                <div v-if="editfieldsMode" class="mt-3">
                  <div class="flex flex-col">
                    <div class="flex flex-col w-full mb-4">
                      <treeselect
                        class="custom-treeselect treeselect-add-new treeselect-select-shadow"
                        v-model="model.leadtags"
                        :multiple="true"
                        :max-height="230"
                        :options="tagsData"
                        :clearOnSelect="true"
                        :closeOnSelect="true"
                        :clearable="false"
                        @select="tagSelected"
                        value-format="object"
                        :placeholder="
                          $t('frontend_groovemail_lead_tag_filter')
                        "
                      />
                    </div>
                  </div>
                </div>
                <div class="mt-3" v-else>
                  <div
                    class="w-full flex flex-wrap"
                    v-if="this.model.leadtags && this.model.leadtags.length"
                  >
                    <div
                      class="
                        mb-2
                        flex
                        rounded-lead-chips
                        text-xs
                        bg-primary text-primary-invert
                        mr-2
                      "
                      v-for="(tag, index) in this.model.leadtags"
                      :key="index"
                    >
                      <div
                        class="py-1 pl-2"
                        :class="{
                          'pr-2': !isUnRestrictedAccount,
                          'pr-1': isUnRestrictedAccount,
                        }"
                      >
                        {{ tag.name }}
                      </div>
                      <div
                        class="py-1 pl-1 pr-2"
                        v-if="isUnRestrictedAccount"
                      >
                        <div class="cursor-pointer" @click="openDeleteConfirmationModal('tag', tag)">
                          <i class="fas fa-times"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <p>
                      {{ $t('frontend_groovemail_mail_lead_show_notags') }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="my-3 w-full">
              <div class="flex items-center">
                <label class="text-sm font-semibold text-grey-600 mr-2">
                  {{ $t('frontend_groovemail_mail_lead_show_lists') }}
                </label>
                <div v-if="!editfieldsMode" class="flex">
                  <span class="text-sm font-semibold text-grey-600">(</span>
                  <div class="flex mx-2">
                    <div class="bg-primary rounded w-5 mr-2"></div>
                    <p class="text-sm font-semibold text-grey-600">
                      :
                      {{ $t('frontend_groovemail_lead_listing_advanced_filters_status_subscribed') }}
                    </p>
                  </div>
                  <span class="text-sm font-semibold text-grey-600">|</span>
                  <div class="flex mx-2">
                    <div class="bg-grey-500 rounded w-5 mr-2"></div>
                    <p class="text-sm font-semibold text-grey-600">
                      :
                      {{ $t('frontend_groovemail_lead_listing_advanced_filters_status_unsubscribed') }}
                    </p>
                  </div>
                  <span class="text-sm font-semibold text-grey-600">)</span>
                </div>
              </div>
              <div class="w-full">
                <div v-if="editfieldsMode" class="mt-3">
                  <div class="flex flex-col">
                    <div class="flex flex-col w-full mb-4">
                      <treeselect
                        class="custom-treeselect treeselect-add-new treeselect-select-shadow"
                        v-model="model.leadlists"
                        :multiple="true"
                        :max-height="230"
                        :options="listData"
                        :clearOnSelect="true"
                        :closeOnSelect="true"
                        :clearable="false"
                        @select="listSelected"
                        value-format="object"
                        :placeholder="
                          $t('frontend_groovemail_lead_list_filter')
                        "
                      />
                    </div>
                  </div>
                </div>
                <div class="mt-3" v-else>
                  <div
                    class="w-full flex flex-wrap"
                    v-if="this.model.leadlists && this.model.leadlists.length"
                  >
                    <div
                      class="
                        mb-2
                        flex
                        rounded-lead-chips
                        text-white text-xs
                        mr-2
                      "
                      v-for="(list, index) in this.model.leadlists"
                      :key="index"
                      :class="{
                        'bg-primary text-primary-invert': !list.is_unsubscribed,
                        'bg-grey-500': list.is_unsubscribed,
                      }"
                    >
                      <div
                        class="py-1 pl-2"
                        :class="{
                          'pr-2': !isUnRestrictedAccount,
                          'pr-1': isUnRestrictedAccount,
                        }"
                      >
                        {{ list.name }}
                      </div>
                      <div
                        class="py-1 pl-1 pr-2"
                        v-if="isUnRestrictedAccount"
                      >
                        <div class="cursor-pointer" @click="openDeleteConfirmationModal('list', list)">
                          <i class="fas fa-times"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <p>
                      {{
                        $t('frontend_groovemail_mail_lead_show_nolists_added')
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="my-3 w-full"
              v-if="
                this.model.completed_sequences &&
                this.model.completed_sequences.length
              "
            >
              <label class="w-full text-sm font-semibold text-grey-600">
                {{ $t('frontend_groovemail_lead_detail_completed_sequences_header') }}
              </label>
              <div class="w-full">
                <div class="mt-3">
                  <div class="w-full flex flex-wrap">
                    <div
                      class="
                        mb-2
                        flex
                        rounded-lead-chips
                        text-xs
                        bg-primary text-primary-invert
                        mr-2
                      "
                      v-for="(sequence, index) in this.model
                        .completed_sequences"
                      :key="index"
                    >
                      <div class="py-1 px-2">{{ sequence.name }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="my-3 w-full"
              v-if="
                this.model.processing_sequences &&
                this.model.processing_sequences.length
              "
            >
              <label class="w-full text-sm font-semibold text-grey-600">
                {{ $t('frontend_groovemail_lead_detail_ongoing_sequences_header') }}
              </label>
              <div class="w-full">
                <div class="mt-3">
                  <div class="w-full flex flex-wrap">
                    <div
                      class="
                        mb-2
                        flex
                        rounded-lead-chips
                        text-xs
                        bg-primary text-primary-invert
                        mr-2
                      "
                      v-for="(sequence, index) in this.model.processing_sequences"
                      :key="index"
                    >
                      <div
                        class="py-1 pl-2"
                        :class="{
                          'pr-2': !isUnRestrictedAccount,
                          'pr-1': isUnRestrictedAccount,
                        }"
                      >
                        {{ sequence.name }}
                      </div>
                      <div
                        class="py-1 pl-1 pr-2"

                      >
                        <div
                          class="cursor-pointer"
                          @click="openDeleteConfirmationModal('sequence', sequence, index)"
                        >
                          <i class="fas fa-times"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </CardLayout>
      <CardLayout class="gm-mail-lead-detail__timeline-card w-2/5 ml-3 leads-deatil-timeline-info">
        <template slot="header">
          <VuePerfectScrollbar
            class="
              border-b-2 border-grey-300
              pt-8
              px-6
              overflow-x-scroll
              whitespace-nowrap
            "
          >
            <gd-tabs
              :tabs="tabs"
              :currentTab="currentTab"
              :disableNotCompleted="false"
              :wrapper-class="'gs-default-tabs'"
              :tab-class="mainTabClass"
              :tab-active-class="'border-primary border-b-2 text-primary gs-default-tabs-item-active'"
              :line-class="'gs-default-tabs-active-line'"
              @onClick="handleTabChange"
            />
          </VuePerfectScrollbar>
        </template>
        <template slot="content">
          <div
            class="relative w-full h-full flex flex-col justify-start mt-6"
          >
            <div class="bg-white w-full px-2">
              <!-- <div class="relative" v-if="currentTab === 'activity'">
                <activity-logs
                  :key="1"
                  :logHeader="
                    $t(
                      'frontend_groovemail_lead_detail_recent_activity_title'
                    )
                  "
                  log_type="all"
                  logRequestUrl="activitylogs"
                ></activity-logs>
              </div>
              <div v-if="currentTab === 'email'">
                <activity-logs
                  :key="2"
                  :logHeader="
                    $t(
                      'frontend_groovemail_lead_detail_recent_emails_title'
                    )
                  "
                  log_type="campaign"
                  logRequestUrl="activitylogs"
                ></activity-logs>
              </div>
              <div v-if="currentTab === 'sequences'">
                <activity-logs
                  :key="3"
                  :logHeader="
                    $t(
                      'frontend_groovemail_lead_detail_recent_sequences_title'
                    )
                  "
                  log_type="sequence"
                  logRequestUrl="activitylogs"
                ></activity-logs>
              </div>
              <div v-if="currentTab === 'forms'">
                <activity-logs
                  :key="4"
                  :logHeader="
                    $t(
                      'frontend_groovemail_lead_detail_recent_forms_title'
                    )
                  "
                  log_type="form"
                  logRequestUrl="activitylogs"
                ></activity-logs>
              </div>
              <div v-if="currentTab === 'automations'">
                <activity-logs
                  :key="5"
                  :logHeader="
                    $t(
                      'frontend_groovemail_lead_detail_recent_automations_title'
                    )
                  "
                  log_type="automation"
                  logRequestUrl="activitylogs"
                ></activity-logs>
              </div> -->
              <div
                v-if="
                  currentTab === 'activity' ||
                  currentTab === 'email' ||
                  currentTab === 'sequences' ||
                  currentTab === 'forms' ||
                  currentTab === 'automations' ||
                  currentTab === 'transactions' ||
                  currentTab === 'subscriptions'
                "
                class="pl-4"
              >
                <div class="absolute coming-soon-div">
                  <gd-button class="text-center px-2 py-1 mr-2 coming-soon-btn">
                    {{ $t('frontend_groovemail_mail_lead_coming_soon') }}
                  </gd-button>
                  
                </div>
                <img
                  alt="coming soon image for activity"
                  src="../../assets/images/pages/lead-detail-activity.png"
                />
              </div>
            </div>
          </div>
        </template>
      </CardLayout>
    </div>

    <gs-named-modal
      name="create-maillist-in-form-modal"
      :title="$t('frontend_groovemail_contacts_step4_create_new_list')"
    >
      <create-list
        :type="'add'"
        :mail_list_id="null"
        :mail_list_data="mail_list_data"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
        @fetchEventsList="fetchLists"
        @closeCreateMaillistModal="closeCreateMaillist"
      >
      </create-list>
    </gs-named-modal>

    <gs-named-modal
      name="create-mailtag-in-form-modal"
      :title="$t('frontend_groovemail_contacts_step4_create_newtag')"
    >
      <create-tag
        :type="'add'"
        :mail_tag_id="null"
        :mail_tag_data="mail_tag_data"
        @showLoader="showLoader"
        @hideLoader="hideLoader"
        @fetchTags="fetchEventsTags"
        @closeCreateTagsModal="closeCreateMailtag"
      ></create-tag>
    </gs-named-modal>

    <confirm-modal
      :ref="`confirmation-delete`"
      :name="`confirmation-delete`"
      :buttonText="confirmModalButtonText"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="confirmModalMessage"
      @confirm="confirmDelete"
    />
  </div>
</template>

<script>
import axios from 'axios';
import Gravatar from 'vue-gravatar';
import {
  required,
  minLength,
  maxLength,
  email,
} from 'vuelidate/lib/validators';

import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Mailtag from '@/models/Mailtag';
import Maillead from '@/models/Maillead';
import themeConfig from '@/theme/themeConfig.js';

// import ActivityLogs from './activity-logs.vue';

import showAlert from '@/components/sweet-alert-popup.js';
import CreateList from '@/components/create-lists.vue';
import CreateTag from '@/components/create-tags.vue';
import CardLayout from '@/components/CardLayout.vue';
import { getCountryCode } from '@/utils/fetchCountryCode.js';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js'

export default {
  middleware: 'auth',
  layout: 'default',
  mixins: [demoModeValuesMixin],
  data() {
    return {
      restrictedContact: false,
      mail_list_data: { name: '', description: '' },
      mail_tag_data: {
        name: '',
        description: '',
        category: [],
        categoryname: '',
      },
      submitted: false,
      default_country_code: 'GB',
      phoneData: {
        countryCallingCode: '44',
        countryCode: 'GB',
        isValid: true,
      },
      customFieldSingleValue: [],
      customFieldMultipleValue: [],
      currentTab: 'activity',
      lead: [],
      contact: '',
      tags: [],
      lists: [],
      currentList: '',
      currentTag: '',
      tagId: '',
      listId: '',
      leadId: '',
      isList: '',
      fullPageLoader: true,
      isLoading: false,
      loaderColor: themeConfig.appPrimaryColor,
      model: {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        company: '',
        address_1: '',
        address_2: '',
        city: '',
        state: '',
        country: '',
        zip: '',
        url: '',
        tax_number: '',
        billing_address: '',
        ip_address: '',
        leadtags: [],
        leadlists: [],
        custom_field: {},
        completed_sequences: [],
        processing_sequences: [],
      },
      editfieldsMode: false,
      created_at_data: '',

      confirmModalMessage: '',
      confirmModalButtonText: '',
      confirmTarget: '',
    };
  },

  metaInfo() {
    return { title: this.$t('frontend_groovemail_email_show_lead') };
  },

  watch: {
    'model.leadlists': function leadListsWatcher() {
      if (this.model.leadlists && this.model.leadlists.length) {
        const listIndex = this.model.leadlists.findIndex((ele) => {
          return ele && ele.id === 'createListOption1';
        });
        if (listIndex >= 0) {
          this.model.leadlists.splice(listIndex, 1);
        }
      }
    },

    'model.leadtags': function leadTagsWatcher() {
      if (this.model.leadtags && this.model.leadtags.length) {
        const tagIndex = this.model.leadtags.findIndex((ele) => {
          return ele && ele.id === 'createTagOption1';
        });
        if (tagIndex >= 0) {
          this.model.leadtags.splice(tagIndex, 1);
        }
      }
    },
  },

  async created() {
    // show loader
    this.showLoader();

    try {
      await this.getMailLeadData();

      const mailLists = await axios.get(`/maillistonly`);
      this.lists = mailLists?.data?.data;
      this.tags = await Mailtag.params({lightweight:true}).$get();

      // hide loader
      this.hideLoader();
    } catch (error) {
      // show error alert
      this.requestErrorAlert(error.response?.data?.error);
    }
  },

  computed: {
		// Used to return demoMode value from store.
		demoMode() {
			return this.$store.state.demoMode.isDemoMode;
		},

    isUnRestrictedAccount() {
      return !this.restrictedContact;
    },

    tabs() {
      return [
        {
          title: `<span class="text-sm leads-field mr-4"></i>&nbsp;${this.$t(
            'frontend_groovemail_lead_detail_activity_tab'
          )}<span>`,
          value: 'activity',
        },
        {
          title: `<span class="text-sm leads-field mr-4"></i>&nbsp;${this.$t(
            'frontend_groovemail_components_pricepoint_sidebar_campaigns'
          )}<span>`,
          value: 'email',
        },
        {
          title: `<span class="text-sm leads-field mr-4"></i>&nbsp;${this.$t(
            'frontend_groovemail_lead_detail_sequence_tab'
          )}<span>`,
          value: 'sequences',
        },
        {
          title: `<span class="text-sm leads-field mr-4"></i>&nbsp;${this.$t(
            'frontend_groovemail_components_sidebar_forms'
          )}<span>`,
          value: 'forms',
        },
        {
          title: `<span class="text-sm leads-field mr-4"></i>&nbsp;${this.$t(
            'frontend_groovemail_contacts_step4_automations'
          )}<span>`,
          value: 'automations',
        },
        {
          title: `<span class="text-sm leads-field mr-4"></i>&nbsp;${this.$t(
            'frontend_groovemail_lead_detail_transaction_tab'
          )}<span>`,
          value: 'transactions',
        },
        {
          title: `<span class="text-sm leads-field mr-4"></i>&nbsp;${this.$t(
            'frontend_groovemail_lead_detail_subscription_tab'
          )}<span>`,
          value: 'subscriptions',
        },
      ];
    },

    tagsData() {
      const tagsData = [];
      if (this.tags && this.tags.length) {
        this.tags.forEach((element) => {
          tagsData.push({
            id: element.id,
            label: element.name,
            name: element.name,
          });
        });
      }
      const tagIndex = tagsData.findIndex((tagEle) => {
        return tagEle.id === 'createTagOption1';
      });
      if (tagIndex < 0) {
        tagsData.push({
          id: 'createTagOption1',
          label: this.$t('frontend_groovemail_mail_tag_new_tag'),
        });
      }
      return tagsData;
    },

    listData() {
      const listData = [];
      if (this.lists && this.lists.length) {
        this.lists.forEach((element) => {
          listData.push({
            id: element.id,
            label: element.name,
            name: element.name,
          });
        });
      }
      const listIndex = listData.findIndex((listEle) => {
        return listEle.id === 'createListOption1';
      });
      if (listIndex < 0) {
        listData.push({
          id: 'createListOption1',
          label: this.$t('frontend_groovemail_mail_list_newlist'),
        });
      }
      return listData;
    },

    months() {
      return [
        this.$t('frontend_groovemail_month_jan_short'),
        this.$t('frontend_groovemail_month_feb_short'),
        this.$t('frontend_groovemail_month_mar_short'),
        this.$t('frontend_groovemail_month_apr_short'),
        this.$t('frontend_groovemail_month_may_short'),
        this.$t('frontend_groovemail_month_jun_short'),
        this.$t('frontend_groovemail_month_jul_short'),
        this.$t('frontend_groovemail_month_aug_short'),
        this.$t('frontend_groovemail_month_sep_short'),
        this.$t('frontend_groovemail_month_oct_short'),
        this.$t('frontend_groovemail_month_nov_short'),
        this.$t('frontend_groovemail_month_dec_short'),
      ];
    },

    mainTabClass() {
      if (this.currentTab === 'activity') {
        return 'pb-6 pl-1 gs-default-tabs-item';
      }
      return 'pb-6 pl-1 gs-default-tabs-item';
    },
  },

  components: {
    Treeselect,
    VuePhoneNumberInput,
    'v-gravatar': Gravatar,
    CreateList,
    CreateTag,
    CardLayout,
    VuePerfectScrollbar,
    // ActivityLogs,
  },

  validations: {
    model: {
      first_name: {
        minLength: minLength(2),
        maxLength: maxLength(30),
      },
      last_name: {
        maxLength: maxLength(30),
      },
      email: {
        required,
        email,
        minLength: minLength(3),
        maxLength: maxLength(150),
      },
      // phone_number: { minLength: minLength(9), maxLength: maxLength(12) },
    },
  },

  async mounted() {
    const countryCode = await getCountryCode();
    this.default_country_code = countryCode ? countryCode : this.default_country_code;
  },

  methods: {
    updateCustomFieldLabel(value) {
      const labelSplit = value.split('_');
      let customFieldLabel = '';
      labelSplit.forEach((ele) => {
        customFieldLabel += `${ele} `;
      });
      return customFieldLabel.trim();
    },

    listSelected(node) {
      if (node.id === 'createListOption1') {
        this.openCreateListModal();
      }
    },

    openCreateListModal() {
      this.mail_list_data.name = '';
      this.mail_list_data.description = '';
      this.$root.$emit('modal-open', 'create-maillist-in-form-modal');
    },

    closeCreateMaillist() {
      this.$root.$emit('modal-close', 'create-maillist-in-form-modal');
    },

    async fetchLists(listData) {
      const mailLists = await axios.get(`/maillistonly`);
      this.lists = mailLists?.data?.data;
      if (listData && listData.data && listData.data.id) {
        this.model.leadlists.push({
          id: listData.data.id,
          label: listData.data.name,
        });
      }
    },

    tagSelected(node) {
      if (node.id === 'createTagOption1') {
        this.openCreateTagModal();
      }
    },

    openCreateTagModal() {
      this.mail_tag_data.name = '';
      this.mail_tag_data.description = '';
      this.mail_tag_data.category = [];
      this.mail_tag_data.categoryname = '';
      this.$root.$emit('modal-open', 'create-mailtag-in-form-modal');
    },

    async fetchEventsTags(tagData) {
      this.tags = await Mailtag.params({lightweight:true}).$get();
      if (tagData && tagData.data && tagData.data.id) {
        this.model.leadtags.push({
          id: tagData.data.id,
          label: tagData.data.name,
        });
      }
    },

    closeCreateMailtag() {
      this.$root.$emit('modal-close', 'create-mailtag-in-form-modal');
    },

    getPhoneData(event) {
      if (event.countryCallingCode) {
        this.phoneData.countryCallingCode = event.countryCallingCode;
      }
      if (event.countryCode) {
        this.phoneData.countryCode = event.countryCode;
      }
      this.phoneData.isValid = event.isValid;
    },

    async getMailLeadData() {
      this.maillead = await Maillead.$find(this.$route.params.id);
      this.getLeadData();
    },

    isValidCountryCode(value) {
      const countryCodeRegex = /^[A-Z]*$/;
      return countryCodeRegex.test(value);
    },

    getLeadData() {
      this.restrictedContact =
        this.maillead && this.maillead.restricted_contact
          ? this.maillead.restricted_contact
          : false;
      this.model.first_name = this.maillead.contact.first_name;
      this.model.last_name = this.maillead.contact.last_name;
      this.model.email = this.maillead.contact.email;
      this.model.address_1 = this.maillead.contact.address_1;
      this.model.phone_number = this.maillead.contact.phone_number;
      this.model.address_2 = this.maillead.contact.address_2;
      this.model.company = this.maillead.contact.company;
      this.model.city = this.maillead.contact.city;
      this.model.state = this.maillead.contact.state;
      this.model.country = this.maillead.contact.country;
      this.model.zip = this.maillead.contact.zip;
      this.model.billing_address = this.maillead.contact.billing_address;
      this.model.ip_address = this.maillead.contact.ip_address;
      this.model.url = this.maillead.contact.url;
      this.model.tax_number = this.maillead.contact.tax_number;
      this.model.company = this.maillead.contact.company;
      this.model.completed_sequences =
        this.maillead.completed_sequences &&
        this.maillead.completed_sequences.length
          ? this.maillead.completed_sequences
          : [];
      this.model.processing_sequences =
        this.maillead.processing_sequences &&
        this.maillead.processing_sequences.length
          ? this.maillead.processing_sequences
          : [];
      this.created_at_data = `${new Date(
        this.maillead.contact.created_at
      ).getDate()} ${
        this.months[new Date(this.maillead.contact.created_at).getMonth()]
      }, ${new Date(this.maillead.contact.created_at).getFullYear()}`;
      if (this.maillead.contact.country_symbol && this.isValidCountryCode(this.maillead.contact.country_symbol)) {
        this.default_country_code = this.maillead.contact.country_symbol;
      }
      const leadtags = [];
      const leadlists = [];

      let currentCustomField = {};
      this.customFieldMultipleValue = [];
      this.customFieldSingleValue = [];
      Object.keys(this.maillead.custom_field).forEach((ele) => {
        this.model.custom_field[ele] = this.maillead.custom_field[ele];
        currentCustomField.key = ele;
        currentCustomField.val = this.maillead.custom_field[ele];
        if (typeof this.maillead.custom_field[ele] === 'object') {
          this.customFieldMultipleValue.push(currentCustomField);
        } else {
          this.customFieldSingleValue.push(currentCustomField);
        }
        currentCustomField = {};
      });

      this.maillead.lists.map((value, key) => {
        if (value.list) leadlists.push(value.list);
      });
      this.maillead.tags.map((value, key) => {
        if (value.tag) leadtags.push(value.tag);
      });

      this.model.leadtags = leadtags;
      this.model.leadlists = leadlists;
    },

    removeCustomField(customFieldKey, fieldValueIndex) {
      this.model.custom_field[customFieldKey].splice(fieldValueIndex, 1);
      // this.savedata();
    },

    handleTabChange(newTab) {
      this.currentTab = newTab;
    },

    // go to previous page on back button click
    goBackToLeadsListing() {
      // go to previous page
      this.$router.go(-1);
      

      // set applying filter to true to show lasted applied filter on leads listing page
      this.$store.dispatch('setApplyingFilter', true);
    },

    showLoader() {
      if (!this.isLoading) {
        this.isLoading = true;
      }
    },

    hideLoader() {
      if (this.isLoading) {
        this.isLoading = false;
      }
    },

    // error message for the request field
    async requestErrorAlert(error) {
      // hide the loader
      this.hideLoader();
      
      await showAlert({
        iconType: 'alert-error',
        html : `
          <style>.swal2-cancel { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-sm text-deep-dark mb-3">${error || this.$t('frontend_backend_error') }</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    editfield() {
      this.editfieldsMode = true;
    },

    turnOffEditMode() {
      this.getLeadData();
      this.editfieldsMode = false;
    },

    async listErrorAlert() {
      // hide the loader
      this.hideLoader();

      // show error alert
      await showAlert({
        iconType: 'alert-error',
        html: `
          <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
          <p class="text-lg font-bold text-deep-dark mb-3"> ${this.$t('frontend_groovemail_lead_detail_last_list_required')}</p>
          <p class="text-sm text-deep-dark"> ${this.$t('frontend_groovemail_lead_detail_last_list_delete_warning')}</p>
        `,
        showCancelButton: false,
        showCloseButton: true,
        confirmButtonColor: themeConfig.appPrimaryColor,
        confirmButtonText: this.$t('frontend_close'),
      });
    },

    async savedata() {
      this.showLoader();
      this.submitted = true;
      
      if (this.model.leadlists.length === 0) {
        // show error alert
        this.listErrorAlert();

        return;
      }

      let validity = true;
      this.$v.model.first_name.$touch();
      this.$v.model.last_name.$touch();
      this.$v.model.email.$touch();
      // this.$v.model.phone_number.$touch();

      validity = !(
        this.$v.model.first_name.$invalid ||
        this.$v.model.last_name.$invalid ||
        this.$v.model.email.$invalid ||
        (!this.phoneData.isValid && this.model.phone_number)
      );

      if (validity) {
        this.maillead.custom_field = this.model.custom_field;
        this.maillead.email = this.model.email.toLowerCase();
        this.maillead.contact.first_name = this.model.first_name;

        Object.keys(this.model.custom_field).forEach((key) => {
          this.maillead.contact[key] = this.model.custom_field[key];
        });

        this.maillead.contact.last_name = this.model.last_name;
        this.maillead.contact.phone_number = this.model.phone_number;
        this.maillead.contact.company = this.model.company;
        this.maillead.contact.address_1 = this.model.address_1;
        this.maillead.contact.address_2 = this.model.address_2;
        this.maillead.contact.city = this.model.city;
        this.maillead.contact.state = this.model.state;
        this.maillead.contact.country = this.model.country;
        this.maillead.contact.zip = this.model.zip;
        this.maillead.contact.url = this.model.url;
        this.maillead.contact.billing_address = this.model.billing_address;
        this.maillead.contact.tax_number = this.model.tax_number;
        this.maillead.contact.ip_address = this.model.ip_address;
        this.maillead.contact.email = this.model.email.toLowerCase();

        if (this.model.phone_number) {
          this.maillead.contact.country_code = `+${this.phoneData.countryCallingCode}`;
          this.maillead.contact.country_symbol = this.phoneData.countryCode;
        }

        const requestTagArr = [];
        const currentTagArr = this.model.leadtags;
        let tagObj;
        currentTagArr.forEach((element) => {
          tagObj = {};
          tagObj.lead_id = this.maillead.contact.lead_id;
          tagObj.tag_id = element.id;
          tagObj.updated_at = this.maillead.contact.updated_at;
          tagObj.created_at = this.maillead.contact.created_at;
          tagObj.tag = element;
          delete tagObj.tag.categories;
          requestTagArr.push(tagObj);
        });
        this.maillead.tags = requestTagArr;

        const tempLeadsList = [];
        this.maillead.lists.forEach((ele) => {
          tempLeadsList.push(ele.list);
        });

        let removedLeadsLists = [];

        removedLeadsLists = tempLeadsList.filter(
          (o) => !this.model.leadlists.some((i) => i.id === o.id)
        );

        const removedListIds = [];
        let removedListObj = {};
        removedLeadsLists.forEach((ele) => {
          removedListObj = {};
          removedListObj.list_id = ele.id;
          removedListIds.push(removedListObj);
        });

        this.maillead.removelists = removedListIds;

        const requestListArr = [];
        const currentListArr = this.model.leadlists;
        let listObj;
        currentListArr.forEach((element) => {
          listObj = {};
          listObj.lead_id = this.maillead.contact.lead_id;
          listObj.list_id = element.id;
          listObj.updated_at = this.maillead.contact.updated_at;
          listObj.created_at = this.maillead.contact.created_at;
          listObj.list = element;
          requestListArr.push(listObj);
        });
        this.maillead.lists = requestListArr;

        try {
          await axios.put(`/maillead/${this.maillead.lead_id}`, this.maillead);
          await this.getMailLeadData();
          
          this.submitted = false;
          this.editfieldsMode = false;
          this.hideLoader();
        } catch (error) {
          // show error alert
          this.requestErrorAlert(error.response?.data?.error);
        }
      }
    },

    async savetaglist(option) {
      this.showLoader();

      if (option === 'tags') {
        this.tagId = this.currentTag.id;
        this.leadId = this.$route.params.id;
        this.isList = 0;
        this.maillead.tags = this.maillead.tags.filter((ele) => {
          return ele.tag_id !== this.currentTag.id;
        });
        // this.maillead.tags = this.model.leadtags;

        try {
          await axios.post('/remove/list/tag', {
            tag_id: this.tagId,
            lead_id: this.leadId,
            is_list: this.isList,
          });
        } catch (error) {
          // show error alert
          this.requestErrorAlert(error.response?.data?.error);
        }
      }

      if (option === 'lists') {
        this.listId = this.currentList.id;
        this.leadId = this.$route.params.id;
        this.isList = 1;
        this.maillead.lists = this.maillead.lists.filter((ele) => {
          return ele.list_id !== this.currentList.id;
        });
        // this.maillead.lists = this.model.leadlists;

        try {
          await axios.post('/remove/list/tag', {
            list_id: this.listId,
            lead_id: this.leadId,
            is_list: this.isList,
          });
        } catch (error) {
          // show error alert
          this.requestErrorAlert(error.response?.data?.error);
        }
      }

      // hide loader
      this.hideLoader();
    },

    // open delete confirmation modal
    async openDeleteConfirmationModal(type ,confirmTarget, index = null) {
      // set confirm target
      this.confirmTarget = {
        index: index || null,
        type,
        ...confirmTarget
      };

      // set confirmation modal message and button text based on confirm target
      if(type === 'tag') {
        this.confirmModalMessage = this.$t('frontend_groovemail_lead_detail_are_you_sure_you_want_to_remove_this_tag');
        this.confirmModalButtonText = this.$t('frontend_delete');
      } else if(type === 'list') {
        this.confirmModalMessage = this.$t('frontend_groovemail_lead_detail_are_you_sure_you_want_to_remove_this_list');
        this.confirmModalButtonText = this.$t('frontend_delete');
      } else if(type === 'sequence') {
        this.confirmModalMessage = this.$t('frontend_groovemail_lead_detail_are_you_sure_you_want_to_remove_this_sequence');
        this.confirmModalButtonText = this.$t('frontend_delete');
      }


      // open confirmation modal
      this.$refs['confirmation-delete'].open();
    },


    // close delete confirmation modal
    closeDeleteConfirmationModal() {
      // reset confirm target
      this.confirmTarget = '';

      // close confirmation modal
      this.$refs['confirmation-delete'].close();
    },


    // confirm deletion of tag or list
    async confirmDelete() {
      if (this.confirmTarget.type === 'tag') {
        this.removeTag(this.confirmTarget);
      } else if (this.confirmTarget.type === 'list') {
        this.removeList(this.confirmTarget);
      } else if (this.confirmTarget.type === 'sequence') {
        this.removeSequence(this.confirmTarget, this.confirmTarget.index);
      }
    },

    // remove tag from contact
    async removeTag(tag) {
      // show loader
      this.showLoader();

      try {
        this.currentTag = tag;
        const index = this.model.leadtags.indexOf(tag);
        this.model.leadtags.splice(index, 1);
        await this.savetaglist('tags');

        // close delete confirmation modal
        this.closeDeleteConfirmationModal();

        // hide loader
        this.hideLoader();
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error);
      }
    },


    // remove list from contact
    async removeList(list) {
      // show loader
      this.showLoader();

      this.currentList = list;
      const listindex = this.model.leadlists.indexOf(list);

      if (this.model.leadlists.length === 1) {
        // show alert if only one list is there
        showAlert({
          iconType: 'alert-error',
          html: `
            <style>.swal2-confirm { color: ${themeConfig.appPrimaryColorInvert} !important; }</style>
            <p class="text-lg font-bold text-deep-dark mb-3"> ${this.$t('frontend_groovemail_lead_detail_last_list_required')}</p>
            <p class="text-sm text-deep-dark"> ${this.$t('frontend_groovemail_lead_detail_last_list_delete_warning')}</p>
          `,
          showCancelButton: false,
          showCloseButton: true,
          confirmButtonColor: themeConfig.appPrimaryColor,
          confirmButtonText: this.$t('frontend_close'),
        });

        // hide loader
        this.hideLoader();
      } else {
        try {
          this.model.leadlists.splice(listindex, 1);
          await this.savetaglist('lists');

          // close delete confirmation modal
          this.closeDeleteConfirmationModal();

          // hide loader
          this.hideLoader();
        } catch (error) {
          // show error alert
          this.requestErrorAlert(error.response?.data?.error);
        }
      }
    },

    // remove sequence from contact
    async removeSequence(sequence, index) {
      // show loader
      this.showLoader();

      try {
        await axios.post('/remove-from-sequence', {
          sequence_id: sequence.id,
          lead_id: this.$route.params.id,
        });

        this.model.processing_sequences.splice(index, 1);

        // close delete confirmation modal
        this.closeDeleteConfirmationModal();

        // hide loader
        this.hideLoader();
      } catch (error) {
        // show error alert
        this.requestErrorAlert(error.response?.data?.error || error.response?.data?.message);
      }
    },
  },
};
</script>

<style lang="scss">
.selectedtags {
  background-color: #3a953a;
  color: #fff;
  padding: 2px 5px;
  border-radius: 5px;
}

.treeselect-select-shadow .vue-treeselect__menu-container .vue-treeselect__menu {
  box-shadow: 0px 0px 40px 0 rgba(22, 29, 37, 0.05) !important;
}

.w-65 {
  width: 65%;
}

.p-1-5 {
  padding: 6px;
}

.w-35 {
  width: 35%;
}

.tabs__item_active .leads-field {
  font-weight: bold;
}

.width-max {
  width: max-content;
}

.btn-common {
  box-shadow: none !important;
  border-radius: 4px !important;
  height: 40px !important;
}

.btn-secondary {
  border: 1px solid #d5d8e5 !important;
}


.coming-soon {
  &-div {
    z-index: 9;
  
    top: 3px;
    right: 20px;
  }

  &-btn {
    height: 24px !important;
    font-size: 14px;
    color: #fff !important;
    border: 1px solid #08c2ab;
    background: #08c2ab !important;
    width: max-content !important;
    border-radius: 4px !important;
  }
}

.rounded-lead-chips {
  border-radius: 6px;
}
</style>

<style scoped>
.gm-mail-lead-detail {
  min-height: 100%;
  padding: 28px;
  color: var(--gs-foreground);
  background: var(--gs-background);
}

.gm-mail-lead-detail__header,
.gm-mail-lead-detail__grid {
  max-width: 1280px;
  margin-right: auto;
  margin-left: auto;
}

.gm-mail-lead-detail__profile-card,
.gm-mail-lead-detail__timeline-card {
  min-width: 0;
  background: var(--gs-surface);
  border: 1px solid var(--gs-border);
  border-radius: var(--gs-radius-lg);
  box-shadow: var(--gs-shadow-sm);
}

@media (max-width: 640px) {
  .gm-mail-lead-detail {
    padding: 16px;
  }

  .gm-mail-lead-detail__header,
  .gm-mail-lead-detail__grid {
    flex-direction: column;
    align-items: stretch;
    gap: 16px;
  }

  .gm-mail-lead-detail__profile-card,
  .gm-mail-lead-detail__timeline-card {
    width: 100%;
    margin: 0;
    border-radius: var(--gs-radius-md);
  }
}
</style>
